import {CurrencyOptionEnum} from '../../constants/enumerations';

export const formatNumber = (value: number) => {
  return value.toLocaleString('es-VE', {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const formatCurrencyValue = (
  value: number | string,
  currencyOption: CurrencyOptionEnum,
  isNumber = true,
): string => {
  if (currencyOption === CurrencyOptionEnum.foreign) {
    return isNumber ? formatMoney(value as number) : `${value}`;
  }
  return isNumber ? formatMoney(value as number, 'Bs. ') : `Bs. ${value}`;
};

export const formatMoney = (value: number, moneySimbol = '$ ') => {
  return `${moneySimbol}${formatNumber(value)}`;
};

export const formatPercent = (value: number, withSymbol = true) => {
  return `${formatNumber(value)} ${withSymbol ? '%' : ''}`;
};

const getMonth = (date: Date) => {
  return date.getMonth() + 1;
};

export const formatDate = (date: Date | null) => {
  let day = '';
  let month = '';
  let year = '';
  if (date) {
    day = date.getDate().toString().padStart(2, '0');
    month = getMonth(date).toString().padStart(2, '0');
    year = date.getFullYear().toString();
  }
  return date ? `${day}/${month}/${year}` : '';
};

export const formatFeeQuote = (day: number, month: number) => {
  const dayFormatted = String(day).padStart(1, '0');
  let monthFormatted = '';
  switch (month) {
    case 1:
      monthFormatted = 'Ene';
      break;
    case 3:
      monthFormatted = 'Feb';
      break;
    case 4:
      monthFormatted = 'Mar';
      break;
    case 4:
      monthFormatted = 'Abr';
      break;
    case 5:
      monthFormatted = 'May';
      break;
    case 6:
      monthFormatted = 'Jun';
      break;
    case 7:
      monthFormatted = 'Jul';
      break;
    case 8:
      monthFormatted = 'Ago';
      break;
    case 9:
      monthFormatted = 'Sep';
      break;
    case 10:
      monthFormatted = 'Oct';
      break;
    case 11:
      monthFormatted = 'Nov';
      break;
    case 12:
      monthFormatted = 'Dec';
      break;
  }
  return `${dayFormatted} ${monthFormatted}`;
};
